<!--
 * @Author: v_smwang
 * @Date: 2020-07-27 19:32:34
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-04-14 16:26:42
 * @FilePath: \src\views\personnel-portrait\personnel-portrait-overview\overview.vue
 * @Description: 描述
 * @Module: 模块路径
-->
<template>
  <div class="personnel-portrait-content">
    <div class="content-header">
      <el-form
        ref="overViewFrom"
        :inline="true"
        :model="formData"
        class="demo-form-inline"
      >
        <el-form-item label="开始日期" prop="start_time">
          <el-date-picker
            v-model="formData.start_time"
            type="date"
            placeholder="选择日期"
            size="mini"
            value-format="timestamp"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期" prop="end_time">
          <el-date-picker
            v-model="formData.end_time"
            type="date"
            placeholder="选择日期"
            size="mini"
            value-format="timestamp"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="平台" prop="platform">
          <el-select
            v-model="formData.platform"
            clearable
            filterable
            placeholder="请选择"
            size="mini"
            @change="onPlatformChange"
          >
            <el-option :value="0" label="大批内业"></el-option>
            <el-option :value="1" label="大批中业"></el-option>
            <el-option :value="2" label="POI"></el-option>
            <el-option :value="3" label="qmap"></el-option>
            <el-option :value="4" label="大挖内业"></el-option>
            <el-option :value="5" label="大挖中业"></el-option>
            <el-option :value="6" label="大挖情报"></el-option>
            <el-option :value="7" label="高精高快速"></el-option>
            <el-option :value="8" label="高精普通路"></el-option>
            <el-option :value="9" label="诺曼底"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产线" prop="production_line">
          <el-select
            v-model="formData.production_line"
            clearable
            filterable
            placeholder="请选择"
            size="mini"
            @change="onProdLineValueChange"
            @clear="onProdLineValueClear"
          >
            <el-option
              v-for="item in prodLineOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="taskTypeChange" label="任务类型" prop="task_type">
          <el-select
            v-model="formData.task_type"
            clearable
            filterable
            placeholder="请选择"
            @change="onTaskTypeValueChange"
            size="mini"
          >
            <el-option
              v-for="item in tasktypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="formData.task_type && formData.production_line != 'merge_0001'" label="任务标签" prop="task_type">
          <el-select
            v-model="formData.task_label"
            clearable
            filterable
            placeholder="请选择"
            size="mini"
          >
            <el-option
              v-for="item in tasklabelOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="供应商" prop="outsourcer">
          <el-select
            v-model="formData.outsourcer"
            clearable
            filterable
            placeholder="请选择"
            size="mini"
            @change="onSupplierValueChange"
          >
            <el-option
              v-for="item in outsourcerOptions"
              :label="item.label"
              :key="item.value"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="统计周期" prop="time_type">
          <el-select
            v-model="formData.time_type"
            filterable
            placeholder="请选择"
            size="mini"
          >
            <el-option
              v-for="item in timeTypeList"
              :key="item.label"
              :label="item.label"
              :value="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" @click="onInquireClick"
            >查询</el-button
          >
          <el-button
            size="mini"
            type="primary"
            @click="onResetClick('overViewFrom')"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
      <div class="tabs">
        <el-tabs class="elTab" v-model="activeTabName">
          <el-tab-pane label="制作员" name="zhizuo"></el-tab-pane>
          <el-tab-pane
            label="内检员"
            name="neijian"
            :disabled="true"
          ></el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="content">
      <div class="content-row">
        <div class="content-column content-column-50">
          <div class="content-title">
            人员综合评价
            <el-tooltip placement="top" popper-class="tooltip-overflow">
              <div slot="content" style="height: 300px; overflow-y: auto; padding: 10px 10px 10px 0" v-html="tooltipContent"></div>
              <i class="el-icon-question"></i>
            </el-tooltip>
          </div>
          <chart
            :chartConfig="[
              {
                name: 'randerChart',
                option: avgScoreConfig.option,
                load: avgScoreConfig.load,
              },
              {
                name: 'barChart',
                option: operatorScoreStepConfig.option,
                load: operatorScoreStepConfig.load,
              },
            ]"
          ></chart>
        </div>
        <div class="content-column content-column-50">
          <!-- <div class="content-title">人员综合排名（421人）</div> -->
          <peoZongRank
            :isIframe="isIframe"
            :start_time="formData.start_time"
            :end_time="formData.end_time"
            :production_line="formData.production_line"
            :task_type="formData.task_type"
            :task_label="formData.task_label"
            :outsourcer="formData.outsourcer"
          ></peoZongRank>
        </div>
      </div>
      <div class="content-row">
        <div class="content-column content-column-50 br5">
          <div class="content-title">
            <span>综合得分时间趋势图</span>
            <el-select
              v-model="comprehensiveScoreTimeTrendGraph.value"
              placeholder="请选择"
              style="width: 180px;float:right"
              size="mini"
              @change="comprehensiveScoreTimeTrendChange($event)">
              <el-option v-for="item in comprehensiveScoreTimeTrendGraph.selects" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <el-select
              v-model="comprehensiveScoreTimeTrendGraph.dimension"
              placeholder="请选择"
              style="width: 100px;float:right"
              size="mini"
              @change="dimensionChange($event, 'comprehensiveScoreTimeTrendGraph')">
              <el-option label="供应商" value="outsourcer" />
              <el-option label="产线" value="production_line" />
            </el-select>
          </div>
          <chart
            :chartConfig="[
              {
                name: 'lineChart',
                option: comprehensiveScoreTimeTrendGraph.option,
                load: comprehensiveScoreTimeTrendGraph.load,
                clear: comprehensiveScoreTimeTrendGraph.clear,
              }
            ]"
          ></chart>
        </div>
        <div class="content-column content-column-50 bl5">
          <div class="content-title">
            <span>评价维度时间趋势</span>
            <el-select
              v-model="evaluationDimensionTimeTrend.value"
              placeholder="请选择"
              style="width: 180px;float:right"
              size="mini"
              @change="evaluationDimensionTimeTrendChange($event)">
              <el-option v-for="item in evaluationDimensionTimeTrend.selects" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <el-select
              v-model="evaluationDimensionTimeTrend.dimension"
              placeholder="请选择"
              style="width: 100px;float:right"
              size="mini"
              @change="dimensionChange($event, 'evaluationDimensionTimeTrend')">
              <el-option label="供应商" value="outsourcer" />
              <el-option label="产线" value="production_line" />
            </el-select>
          </div>
          <chart
            :chartConfig="[
              {
                name: 'lineChart',
                option: evaluationDimensionTimeTrend.option,
                load: evaluationDimensionTimeTrend.load,
                clear: evaluationDimensionTimeTrend.clear,
              },
            ]"
          ></chart>
        </div>
      </div>
      <div class="content-row">
        <div class="content-column content-column-50 br5">
          <div class="content-title">产线综合维度评价</div>
          <chart
            :chartConfig="[
              {
                name: 'stackBarChart',
                option: synthesizeScoreStepDistributionProdLineConfig.option,
                load: synthesizeScoreStepDistributionProdLineConfig.load,
              },
            ]"
          ></chart>
        </div>
        <div class="content-column content-column-50 bl5">
          <div class="content-title">供应商综合维度评价</div>
          <chart
            :chartConfig="[
              {
                name: 'stackBarChart',
                option:
                  synthesizeScoreStepDistributionDataOutsourcerConfig.option,
                load: synthesizeScoreStepDistributionDataOutsourcerConfig.load,
              },
            ]"
          ></chart>
        </div>
      </div>
      <div class="content-row">
        <div class="content-column content-column-30">
          <div class="content-title">
            <span>人员单项评价</span>
            <selectDropDown></selectDropDown>
          </div>
          <chart
            :chartConfig="[
              {
                name: 'barChart',
                option: singleOperatorScoreStepConfig.option,
                load: singleOperatorScoreStepConfig.load,
              },
            ]"
          ></chart>
        </div>
        <div class="content-column content-column-70">
          <peoSingRank
            :isIframe="isIframe"
            :start_time="formData.start_time"
            :end_time="formData.end_time"
            :production_line="formData.production_line"
            :outsourcer="formData.outsourcer"
            :task_type="formData.task_type"
          ></peoSingRank>
        </div>
      </div>
      <div class="content-row">
        <div class="content-column content-column-50 br5">
          <div class="content-title">产线维度单项评价</div>
          <chart
            :chartConfig="[
              {
                name: 'stackBarChart',
                option:
                  singletonSynthesizeScoreStepDistributionProdLineConfig.option,
                load:
                  singletonSynthesizeScoreStepDistributionProdLineConfig.load,
              },
            ]"
          ></chart>
        </div>
        <div class="content-column content-column-50 bl5">
          <div class="content-title">供应商维度单项评价</div>
          <chart
            :chartConfig="[
              {
                name: 'stackBarChart',
                option:
                  singletonSynthesizeScoreStepDistributionOutsourcerConfig.option,
                load:
                  singletonSynthesizeScoreStepDistributionOutsourcerConfig.load,
              },
            ]"
          ></chart>
        </div>
      </div>
      <div class="content-row">
        <div class="content-column content-column-50">
          <div class="content-title">
            提质提效评价
            <b
              v-if="formData.production_line === '' || !isShowTip"
              style="color: red"
            >
              （
              <b v-if="formData.production_line === ''">当前无产线筛选值</b>
              <b v-if="!isShowTip">当前模块无数据展示</b>
              ）
            </b>
            <span class="export-span" @click="exportDetail('1')">导出</span>
          </div>
          <chart
            :chartConfig="[
              {
                name: 'scatterChart',
                option: qualityEfficiencyScatterConfig.option,
                load: qualityEfficiencyScatterConfig.load,
                clear: qualityEfficiencyScatterConfig.clear,
              },
            ]"
          ></chart>
        </div>
        <div class="content-column content-column-50">
          <div class="content-title">
            <span class="export-span" @click="exportDetail('2')">导出</span>
          </div>
          <chart
            ref="qualityEfficiencyComprehensiveRef"
            :chartConfig="[
              {
                name: 'barChart',
                option: qualityEfficiencyComprehensiveConfig.option,
                load: qualityEfficiencyComprehensiveConfig.load,
                clear: qualityEfficiencyComprehensiveConfig.clear,
              },
            ]"
          ></chart>
        </div>
      </div>
      <div class="content-row">
        <div class="content-column content-column-50 br5">
          <div class="content-title">
            <span class="export-span" @click="exportDetail('3')">导出</span>
          </div>
          <chart
            :chartConfig="[
              {
                name: 'lineChart',
                option: qualityEfficiencyEfficiencyConfig.option,
                load: qualityEfficiencyEfficiencyConfig.load,
                clear: qualityEfficiencyEfficiencyConfig.clear,
              },
            ]"
          ></chart>
        </div>
        <div class="content-column content-column-50 bl5">
          <div class="content-title">
            <span class="export-span" @click="exportDetail('4')">导出</span>
          </div>
          <chart
            :chartConfig="[
              {
                name: 'lineChart',
                option: qualityEfficiencyQualityConfig.option,
                load: qualityEfficiencyQualityConfig.load,
                clear: qualityEfficiencyQualityConfig.clear,
              },
            ]"
          ></chart>
        </div>
      </div>
      <div class="content-row">
        <div class="content-column">
          <zongHeGaiLan
            :isIframe="isIframe"
            :start_time="formData.start_time"
            :end_time="formData.end_time"
            :production_line="formData.production_line"
            :outsourcer="formData.outsourcer"
            :task_type="formData.task_type"
          ></zongHeGaiLan>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getProductionLine,
  getOutsourcer,
  getTasktype,
  getTasklabel,
  getAvgScore,
  getOperatorScoreStep,
  avgScoreTrend,
  singletonZbTrend,
  getSynthesizeScoreStepDistribution,
  getSingleOperatorScoreStep,
  getSingletonSynthesizeScoreStepDistribution,
  getQualityEfficiencyScatter,
  getQualityEfficiencyScatterExport,
  getQualityEfficiencyComprehensive,
  getQualityEfficiencyComprehensiveExport,
  getQualityEfficiencyEfficiency,
  getQualityEfficiencyEfficiencyExport,
  getQualityEfficiencyQuality,
  getQualityEfficiencyQualityExport,
} from '@/api/personnelPortraitOverview';
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import chart from '../../../components/chart/index';
import zongHeGaiLan from './table/zongHeGaiLan';
import peoSingRank from './table/peoSingRank';
import peoZongRank from './table/peoZongRank';
import selectDropDown from './table/selectDropDown';
import { downloadBlobFile } from '@/utils/download';
import api from '@/api/pv_report';
import { tooltipContent } from './overviewConfig';
const { mapState, mapMutations, mapActions } = createNamespacedHelpers('personnelPortraitOverview');

const mixin = {
  computed: {
    ...mapState({
      activeTabName: state => state.activeTabName,
      dropDownNum: state => state.dropDownNum,
    }),
  },
  methods: {
    ...mapMutations([
      'UPDATE_FORMDATA',
      'UPDATE_ACTIVETABNAME',
      'UPDATE_INQRIRENUM',
    ]),
    ...mapActions([]),
  },
};

export default {
  data() {
    return {
      taskTypeChange: false,
      tooltipContent: '',
      isIframe: false,
      prodLineOptions: [],
      tasktypeOptions: [],
      tasklabelOptions: [], // 任务标签列表
      outsourcerOptions: [],
      timeTypeList: [
        {
          label: '天',
        },
        {
          label: '自然周',
        },
        {
          label: '汇报周',
        },
        {
          label: '自然月',
        },
        {
          label: '结算月',
        },


      ],
      avgScoreConfig: {
        option: {},
        load: false,
        clear: false,
      },
      operatorScoreStepConfig: {
        option: {},
        load: false,
        clear: false,
      },
      singleOperatorScoreStepConfig: {
        option: {},
        load: false,
        clear: false,
      },
      comprehensiveScoreTimeTrendGraph: {
        option: {},
        load: false,
        clear: false,
        value: 0,
        dimension: 'outsourcer',
        selects: [
          { value: 0, label: '整体得分' },
          { value: 1, label: '验收一次缺陷率' },
          { value: 2, label: '制作效率' },
          { value: 3, label: '制作产量' },
          { value: 4, label: '平均有效时长' },
        ],
      },
      evaluationDimensionTimeTrend: {
        option: {},
        load: false,
        clear: false,
        value: 1,
        dimension: 'outsourcer',
        selects: [
          { value: 1, label: '验收一次缺陷率' },
          { value: 2, label: '制作效率' },
          { value: 3, label: '制作产量' },
          { value: 4, label: '平均有效时长' },
        ],
      },
      synthesizeScoreStepDistributionProdLineConfig: {
        option: {},
        load: false,
        clear: false,
      },
      synthesizeScoreStepDistributionDataOutsourcerConfig: {
        option: {},
        load: false,
        clear: false,
      },
      singletonSynthesizeScoreStepDistributionProdLineConfig: {
        option: {},
        load: false,
        clear: false,
      },
      singletonSynthesizeScoreStepDistributionOutsourcerConfig: {
        option: {},
        load: false,
        clear: false,
      },
      qualityEfficiencyScatterConfig: {
        option: {
          isJump: true, // 是否点击图形跳转
        },
        load: false,
        clear: false,
      },
      qualityEfficiencyComprehensiveConfig: {
        option: {},
        load: false,
        clear: false,
      },
      qualityEfficiencyEfficiencyConfig: {
        option: {},
        load: false,
        clear: false,
      },
      qualityEfficiencyQualityConfig: {
        option: {},
        load: false,
        clear: false,
      },
      isShowTip: false,
    };
  },
  mixins: [mixin],
  computed: {
    formData: {
      get() {
        return this.$store.state.personnelPortraitOverview.formData;
      },
      set(payload) {
        this.UPDATE_FORMDATA(payload);
      },
    },
    activeTabName: {
      get() {
        return this.$store.state.personnelPortraitOverview.activeTabName;
      },
      set(payload) {
        this.UPDATE_ACTIVETABNAME(payload);
      },
    },
  },
  components: {
    chart,
    zongHeGaiLan,
    peoSingRank,
    selectDropDown,
    peoZongRank,
  },
  created() {
    if (window.location.href.includes('tianshu')) {
      this.PV_report();
    }
    // let message = 2
    // window.parent.postMessage(message, '*')
    this.formData.start_time = moment()
      .subtract(7, 'days')
      .startOf('day')
      .valueOf();
    this.formData.end_time = moment()
      .subtract(1, 'days')
      .startOf('day')
      .valueOf();
  },
  mounted() {
    this.tooltipContent = tooltipContent;
    this.isIframe = window.location.href.search('iframe=1') !== -1;
    this.init();
  },
  watch: {
    dropDownNum(val) {
      this.singleOperatorScoreStepConfig.load = true;
      this.singletonSynthesizeScoreStepDistributionProdLineConfig.load = true;
      this.singletonSynthesizeScoreStepDistributionOutsourcerConfig.load = true;
      this.getSingleOperatorScoreStepData({
        ...this.formData,
        operator_type: this.activeTabName,
        zb: this.dropDownNum,
      }); // 人员单项分数阶梯分布
      this.getSingletonSynthesizeScoreStepDistributionDataProdLine({
        ...this.formData,
        operator_type: this.activeTabName,
        zb: this.dropDownNum,
      }); // 人员单项评价——产线
      this.getSingletonSynthesizeScoreStepDistributionDataOutsourcer({
        ...this.formData,
        operator_type: this.activeTabName,
        zb: this.dropDownNum,
      }); // 人员单项评价——供应商
    },
    activeTabName(val) {
      this.drawCharts({
        ...this.formData,
        operator_type: this.activeTabName,
      }); // 绘制图表
    },
    'formData.start_time': {
      handler(newVal, oldVal) {
        this.setProdLineAndOutsourcer();
      },
      // immediate: true,
      deep: true,
    },
    'formData.end_time': {
      handler(newVal, oldVal) {
        this.setProdLineAndOutsourcer();
      },
      // immediate: true,
      deep: true,
    },
  },
  methods: {
    setProdLineAndOutsourcer() {
      this.formData.production_line = '';
      this.formData.task_type = '';
      const params = {
        operator_type: this.activeTabName,
        start_time: this.formData.start_time,
        end_time: this.formData.end_time,
        production_line: this.formData.production_line,
        platform: this.formData.platform, // 默认内业
        time_type: this.formData.time_type,
        // outsourcer: this.formData.outsourcer,
        // task_type: this.formData.task_type,
      };
      // 初始化
      this.initProdLineOptions(params); // 筛选获取产线
      this.initOutsourcertaskType(params); // 筛选获取任务类型
      // this.initOutsourcertaskLabel(params); // 筛选获取任务标签
      this.initOutsourcerOptions(params); // 筛选获取供应商
      this.taskTypeChange = false;
    },
    init() {
      // 初始化参数
      // 初始化参数只有这些暂时
      const initParams = {
        operator_type: 'zhizuo',
        start_time: moment().subtract(7, 'days')
          .startOf('day')
          .valueOf(),
        end_time: moment().subtract(1, 'days')
          .startOf('day')
          .valueOf(),
        platform: 0, // 默认内业
        time_type: '天',
      };
      console.log(this.formData, '----------------初始化--------------');
      // 初始化
      this.initProdLineOptions(initParams); // 筛选获取产线
      this.initOutsourcertaskType(initParams); // 筛选获取任务类型
      // this.initOutsourcertaskLabel(initParams); // 筛选获取任务标签
      this.initOutsourcerOptions(initParams); // 筛选获取供应商
      this.drawCharts(initParams); // 绘制图表
    },
    drawCharts(params = {}) {
      // 设置启动load
      this.avgScoreConfig.load = true;
      this.operatorScoreStepConfig.load = true;
      this.singleOperatorScoreStepConfig.load = true;
      this.comprehensiveScoreTimeTrendGraph.load = true;
      this.evaluationDimensionTimeTrend.load = true;
      this.synthesizeScoreStepDistributionProdLineConfig.load = true;
      this.synthesizeScoreStepDistributionDataOutsourcerConfig.load = true;
      this.singletonSynthesizeScoreStepDistributionProdLineConfig.load = true;
      this.singletonSynthesizeScoreStepDistributionOutsourcerConfig.load = true;
      this.qualityEfficiencyScatterConfig.load = true;
      this.qualityEfficiencyComprehensiveConfig.load = true;
      this.qualityEfficiencyEfficiencyConfig.load = true;
      this.qualityEfficiencyQualityConfig.load = true;

      // 拉取数据
      this.getAvgScoreData(params); // 整体平均分数雷达图
      this.getOperatorScoreStepData(params); // 人员综合分数阶梯分布图
      this.getComprehensiveScoreTimeTrendGraph({
        ...params,
        zb: this.dropDownNum,
      }); // 综合得分时间趋势图
      this.getEvaluationDimensionTimeTrend(params); // 评价维度时间趋势
      this.getSynthesizeScoreStepDistributionDataProdLine(params); // 人员综合维度评价——产线
      this.getSynthesizeScoreStepDistributionDataOutsourcer(params); // 人员综合维度评价——供应商
      this.getSingleOperatorScoreStepData({
        ...params,
        zb: this.dropDownNum,
      }); // 人员单项分数阶梯分布
      this.getSingletonSynthesizeScoreStepDistributionDataProdLine({
        ...params,
        zb: this.dropDownNum,
      }); // 人员单项评价——产线
      this.getSingletonSynthesizeScoreStepDistributionDataOutsourcer({
        ...params,
        zb: this.dropDownNum,
      }); // 人员单项评价——供应商
      this.getQualityEfficiencyScatterData(params); // 提质提效散点图
      this.getQualityEfficiencyComprehensiveData(params); // 柱状图
      this.getQualityEfficiencyEfficiencyData(params); // 提质提效-分层效率分布
      this.getQualityEfficiencyQualityData(params); // 提质提效-分层质量分布
    },
    /**
     * 筛选获取产线
     */
    async initProdLineOptions(params = {}) {
      // 筛选获取产线
      const res = await getProductionLine(params);
      if (res && res.length > 0) {
        const prodLineOptions = [];
        res.map((item) => {
          prodLineOptions.push({
            value: item.id,
            label: item.label,
          });
        });
        this.prodLineOptions = prodLineOptions;
      } else {
        this.prodLineOptions = [];
      }
    },
    /**
     * 筛选获取供应商
     */
    async initOutsourcerOptions(params = {}) {
      // 筛选获取供应商
      const res = await getOutsourcer(params);

      if (res && res.length > 0) {
        const outsourcerOptions = [];
        res.map((item) => {
          outsourcerOptions.push({
            value: item.id,
            label: item.label,
          });
        });
        this.outsourcerOptions = outsourcerOptions;
      }
    },
    /**
     * 筛选获取任务类型
     */
    async initOutsourcertaskType(params = {}) {
      this.formData.task_type = '';
      this.formData.task_label = '';
      const res = await getTasktype(params);
      if (res && res.length > 0) {
        this.tasktypeOptions = res.map(item => ({ value: item.id, label: item.label }));
        this.taskTypeChange = true;
      } else {
        this.tasktypeOptions = [];
      }
    },
    /**
     * 筛选获取任务标签
     */
    async initOutsourcertaskLabel(params = {}) {
      this.formData.task_label = '';
      const res = await getTasklabel(params);
      // console.log(res, '任务类型res');
      if (res && res.length > 0) {
        this.tasklabelOptions = res.map(item => ({ value: item.id, label: item.label }));
      } else {
        this.tasklabelOptions = [];
      }
    },
    /**
     * 整体平均分数雷达图
     */
    async getAvgScoreData(params = {}) {
      // 调用数据更新雷达图
      const res = await getAvgScore(params);
      this.avgScoreConfig.load = false;

      let titleText = '';
      let randerIndicator = [
        {
          name: '质量',
          max: 100,
        },
        {
          name: '效率',
          max: 100,
        },
        {
          name: '产量',
          max: 100,
        },
        {
          name: '有效\n时长',
          max: 100,
        },
      ];
      let series = [];
      if (res) {
        titleText =          `整体平均分数：${((res.cl + res.xl + res.zl + res.hs) || 0).toFixed(2)}`;
        randerIndicator = [
          {
            name: `质量\n(${(res.zl_standard || 0).toFixed(2)})`,
            max: (res.zl_standard || 0).toFixed(2),
          },
          {
            name: `效率\n(${(res.xl_standard || 0).toFixed(2)})`,
            max: (res.xl_standard || 0).toFixed(2),
          },
          {
            name: `产量\n(${(res.cl_standard || 0).toFixed(2)})`,
            max: (res.cl_standard || 0).toFixed(2),
          },
          {
            name: `有效\n时长\n(${(res.hs_standard || 0).toFixed(2)})`,
            max: (res.hs_standard || 0).toFixed(2),
          },
        ];
        series = [
          {
            data: [
              {
                value: [
                  res.zl && res.zl.toFixed(2),
                  res.xl && res.xl.toFixed(2),
                  res.cl && res.cl.toFixed(2),
                  res.hs && res.hs.toFixed(2),
                ],
              },
            ],
          },
        ];
      }
      this.avgScoreConfig.option = {
        title: {
          text: titleText,
        },
        radar: {
          indicator: randerIndicator,
        },
        series,
      };
    },
    /**
     * 人员综合分数阶梯分布图
     */
    async getOperatorScoreStepData(params = {}) {
      const res = await getOperatorScoreStep(params);
      this.operatorScoreStepConfig.load = false;
      const yAxisData = [];
      const seriesData = [];
      let totalCount = 0;
      if (res && res.length > 0) {
        res.map((item) => {
          totalCount = totalCount + item.count;
          yAxisData.push({
            value: `${item.start}~${item.end}`,
          });
          seriesData.push({
            value: item.count,
            label: {
              start: item.start,
              end: item.end,
              show: true,
              table: 'zongRank', // 固定对应右侧表格
            },
          });
        });
      }
      this.operatorScoreStepConfig.option = {
        title: {
          text: '人员综合分数阶梯分布',
        },
        tooltip: {
          formatter(params) {
            return (
              `数量：${
                params[0].value
              }</br>`
              + `百分比：${
                ((params[0].value / totalCount) * 100).toFixed(2)
              }%`
            );
          },
        },
        yAxis: {
          show: true,
          type: 'category',
          data: yAxisData,
        },
        series: [
          {
            type: 'bar',
            name: '数量',
            itemStyle: {
              color: '#334FC5',
            },
            legendHoverLink: true,
            data: seriesData,
          },
        ],
      };
    },
    /**
     * 综合得分时间趋势图
     */
    async getComprehensiveScoreTimeTrendGraph(params = {}) {
      const data = { ...params, ...{ dimension: this.comprehensiveScoreTimeTrendGraph.dimension },...{zb:this.comprehensiveScoreTimeTrendGraph.value} };
      const res = await avgScoreTrend(data);
      this.comprehensiveScoreTimeTrendGraph.load = false;
      this.comprehensiveScoreTimeTrendGraph.clear = false;
      const series = res.column.map((item, index) => ({
        name: item,
        label: {
          show: true,
        },
        type: 'line',
        stack: '',
        data: res.data[item],
      }));
      this.comprehensiveScoreTimeTrendGraph.option = {
        legend: {
          top: '30',
          orient: 'horizontal',
          type: 'scroll',
          data: res.column,
        },
        xAxis: {
          type: 'category',
          data: res.row,
        },
        yAxis: {
          type: 'value',
        },
        series,
        dataZoom: [
          {
            type: 'inside',
            xAxisIndex: [0],
            minValueSpan: 0,
            maxValueSpan: 9,
          },
          {
            type: 'slider',
            xAxisIndex: [0],
            minValueSpan: 0,
            maxValueSpan: 9,
          },
        ],
      };
    },
    /**
     * 评价维度时间趋势
     */
    async getEvaluationDimensionTimeTrend(params = {}) {
      const { evaluationDimensionTimeTrend: { dimension, value: zb } } = this;
      const data = { ...params, ...{ dimension }, ...{ zb } };
      const res = await singletonZbTrend(data);
      this.evaluationDimensionTimeTrend.load = false;
      this.evaluationDimensionTimeTrend.clear = false;
      const series = res.column.map((item, index) => ({
        name: item,
        label: {
          show: true,
          formatter: (v) => {
            // console.log(v,this.evaluationDimensionTimeTrend.value ,'vvvvvvv')
            if (this.evaluationDimensionTimeTrend.value === 1) {
              return `${(v.data * 100).toFixed(2)}%`;
            }
            return v.data;
          },
        },
        type: 'line',
        stack: '',
        data: res.data[item],
      }));
      this.evaluationDimensionTimeTrend.option = {
        legend: {
          top: '30',
          orient: 'horizontal',
          type: 'scroll',
          data: res.column,
        },
        // 更改悬停展示数据
        // tooltip:{
        //   trigger: 'axis', 
        //   formatter(data,val) {
        //   let dataArr = ''
        //   let tooltipData = ''
        //   data.map((item,index)=>{
        //     console.log(item,index,'index')
        //     dataArr+=item.marker + item.seriesName + '：'+(item.value.toFixed(2)) + '<br/>'
        //     tooltipData = data[index].name +'<br/>' + dataArr;
        //   })
        //   return tooltipData
        //   }
        // },
        xAxis: {
          type: 'category',
          data: res.row,
        },
        yAxis: {
          type: 'value',
        },
        series,
        dataZoom: [
          {
            type: 'inside',
            xAxisIndex: [0],
            minValueSpan: 0,
            maxValueSpan: 9,
          },
          {
            type: 'slider',
            xAxisIndex: [0],
            minValueSpan: 0,
            maxValueSpan: 9,
          },
        ],
      };
    },
    /**
     * 人员综合维度评价——产线
     */
    async getSynthesizeScoreStepDistributionDataProdLine(params = {}) {
      const res = await getSynthesizeScoreStepDistribution({
        ...params,
        dimension: 'production_line',
      });
      console.log(res,'chanxan')
      this.synthesizeScoreStepDistributionProdLineConfig.load = false;
      const xAxisData = [];
      let series = [];
      const legendData = [];
      const seriesObj = {};
      if (res && res.length > 0) {
        res.map((item) => {
          xAxisData.push(item.label);

          item.data.map((itemData) => {
            const _lagenText = `${itemData.start}~${itemData.end}`;
            if (legendData.indexOf(_lagenText) === -1) {
              legendData.push(_lagenText);
              seriesObj[_lagenText] = [];
              seriesObj[_lagenText].push({
                value: itemData.count,
                label: {
                  rate: itemData.rate,
                  total_count: item.total_count,
                  total_rate: item.rate,
                },
              });
            } else {
              seriesObj[_lagenText].push({
                value: itemData.count,
                label: {
                  rate: itemData.rate,
                  total_count: item.total_count,
                  total_rate: item.rate,
                },
              });
            }
          });
        });

        series = this.getStackBarSeries(seriesObj);
      }
      this.synthesizeScoreStepDistributionProdLineConfig.option = {
        title: {
          text: '产线维度综合分数阶梯分布',
        },
        tooltip: {
          formatter: (params) => {
            let text =              `${params[0].name || ''
            }&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;人数:${
              params[0].data.label.total_count
            }&nbsp;&nbsp;&nbsp;&nbsp;百分比:${
              (params[0].data.label.total_rate * 100).toFixed(2)
            }%`;
            params.map((item) => {
              text =                `${text
              }<br/>${
                item.seriesName
              }&nbsp;&nbsp;&nbsp;&nbsp;人数:${
                item.data.value
              }&nbsp;&nbsp;&nbsp;&nbsp;百分比:${
                (item.data.label.rate * 100).toFixed(2)
              }%`;
            });
            return text;
          },
        },
        legend: {
          data: legendData,
        },
        xAxis: [
          {
            type: 'category',
            data: xAxisData,
          },
        ],
        series,
      };
    },
    /**
     * 供应商维度综合分数阶梯分布图
     */
    async getSynthesizeScoreStepDistributionDataOutsourcer(params = {}) {
      const res = await getSynthesizeScoreStepDistribution({
        ...params,
        dimension: 'outsourcer',
      });
      this.synthesizeScoreStepDistributionDataOutsourcerConfig.load = false;
      const xAxisData = [];
      let series = [];
      const legendData = [];
      const seriesObj = {};
      if (res && res.length > 0) {
        res.map((item) => {
          xAxisData.push(item.label);

          item.data.map((itemData) => {
            const _lagenText = `${itemData.start}~${itemData.end}`;
            if (legendData.indexOf(_lagenText) === -1) {
              legendData.push(_lagenText);
              seriesObj[_lagenText] = [];
              seriesObj[_lagenText].push({
                value: itemData.count,
                label: {
                  rate: itemData.rate,
                  total_count: item.total_count,
                  total_rate: item.rate,
                },
              });
            } else {
              seriesObj[_lagenText].push({
                value: itemData.count,
                label: {
                  rate: itemData.rate,
                  total_count: item.total_count,
                  total_rate: item.rate,
                },
              });
            }
          });
        });

        series = this.getStackBarSeries(seriesObj);
      }
      // 写在外边是因为如果未取到数据要清空
      this.synthesizeScoreStepDistributionDataOutsourcerConfig.option = {
        title: {
          text: '供应商维度综合分数阶梯分布',
        },
        tooltip: {
          formatter: (params) => {
            let text =              `${params[0].name || ''
            }&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;人数:${
              params[0].data.label.total_count
            }&nbsp;&nbsp;&nbsp;&nbsp;百分比:${
              (params[0].data.label.total_rate * 100).toFixed(2)
            }%`;
            params.map((item) => {
              text =                `${text
              }<br/>${
                item.seriesName
              }&nbsp;&nbsp;&nbsp;&nbsp;人数:${
                item.data.value
              }&nbsp;&nbsp;&nbsp;&nbsp;百分比:${
                (item.data.label.rate * 100).toFixed(2)
              }%`;
            });
            return text;
          },
        },
        legend: {
          data: legendData,
        },
        xAxis: [
          {
            type: 'category',
            data: xAxisData,
          },
        ],
        series,
      };
    },
    /**
     * 人员单项分数阶梯分布
     */
    async getSingleOperatorScoreStepData(params = {}) {
      const res = await getSingleOperatorScoreStep(params);
      this.singleOperatorScoreStepConfig.load = false;
      const yAxisData = [];
      const seriesData = [];
      let totalCount = 0;
      if (res && res.length > 0) {
        res.map((item) => {
          totalCount = totalCount + item.count;
          yAxisData.push({
            value: `${item.start}~${item.end}`,
          });
          seriesData.push({
            value: item.count,
            label: {
              start: item.start,
              end: item.end,
              show: true,
              table: 'singRank', // 固定对应右侧表格
            },
          });
        });
      }
      this.singleOperatorScoreStepConfig.option = {
        tooltip: {
          formatter(params) {
            return (
              `数量：${
                params[0].value
              }</br>`
              + `百分比：${
                ((params[0].value / totalCount) * 100).toFixed(2)
              }%`
            );
          },
        },
        yAxis: {
          show: true,
          type: 'category',
          data: yAxisData,
        },
        series: [
          {
            type: 'bar',
            name: '数量',
            itemStyle: {
              color: '#334FC5',
            },
            legendHoverLink: true,
            data: seriesData,
          },
        ],
      };
    },
    /**
     * 人员单项评价——产线
     */
    async getSingletonSynthesizeScoreStepDistributionDataProdLine(params = {}) {
      const res = await getSingletonSynthesizeScoreStepDistribution({
        ...params,
        dimension: 'production_line',
      });
      this.singletonSynthesizeScoreStepDistributionProdLineConfig.load = false;
      const xAxisData = [];
      let series = [];
      const legendData = [];
      const seriesObj = {};
      if (res && res.length > 0) {
        res.map((item) => {
          xAxisData.push(item.label);

          item.data.map((itemData) => {
            const _lagenText = `${itemData.start}~${itemData.end}`;
            if (legendData.indexOf(_lagenText) === -1) {
              legendData.push(_lagenText);
              seriesObj[_lagenText] = [];
              seriesObj[_lagenText].push({
                value: itemData.count,
                label: {
                  rate: itemData.rate,
                  total_count: item.total_count,
                  total_rate: item.rate,
                },
              });
            } else {
              seriesObj[_lagenText].push({
                value: itemData.count,
                label: {
                  rate: itemData.rate,
                  total_count: item.total_count,
                  total_rate: item.rate,
                },
              });
            }
          });
        });

        series = this.getStackBarSeries(seriesObj);
      }
      this.singletonSynthesizeScoreStepDistributionProdLineConfig.option = {
        title: {
          text:
            `产线维度${
              this.getTitleText(this.activeTabName, params.zb)
            }达标比阶梯分布`,
        },
        tooltip: {
          formatter: (params) => {
            let text =              `${params[0].name || ''
            }&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;人数:${
              params[0].data.label.total_count
            }&nbsp;&nbsp;&nbsp;&nbsp;百分比:${
              (params[0].data.label.total_rate * 100).toFixed(2)
            }%`;
            params.map((item) => {
              text =                `${text
              }<br/>${
                item.seriesName
              }&nbsp;&nbsp;&nbsp;&nbsp;人数:${
                item.data.value
              }&nbsp;&nbsp;&nbsp;&nbsp;百分比:${
                (item.data.label.rate * 100).toFixed(2)
              }%`;
            });
            return text;
          },
        },
        legend: {
          data: legendData,
        },
        xAxis: [
          {
            type: 'category',
            data: xAxisData,
          },
        ],
        series,
      };
    },
    /**
     * 人员单项评价——供应商
     */
    async getSingletonSynthesizeScoreStepDistributionDataOutsourcer(params = {}) {
      const res = await getSingletonSynthesizeScoreStepDistribution({
        ...params,
        dimension: 'outsourcer',
      });
      this.singletonSynthesizeScoreStepDistributionOutsourcerConfig.load = false;
      const xAxisData = [];
      let series = [];
      const legendData = [];
      const seriesObj = {};
      if (res && res.length > 0) {
        res.map((item) => {
          xAxisData.push(item.label);

          item.data.map((itemData) => {
            const _lagenText = `${itemData.start}~${itemData.end}`;
            if (legendData.indexOf(_lagenText) === -1) {
              legendData.push(_lagenText);
              seriesObj[_lagenText] = [];
              seriesObj[_lagenText].push({
                value: itemData.count,
                label: {
                  rate: itemData.rate,
                  total_count: item.total_count,
                  total_rate: item.rate,
                },
              });
            } else {
              seriesObj[_lagenText].push({
                value: itemData.count,
                label: {
                  rate: itemData.rate,
                  total_count: item.total_count,
                  total_rate: item.rate,
                },
              });
            }
          });
        });

        series = this.getStackBarSeries(seriesObj);
      }

      const _text =        `供应商维度${
        this.getTitleText(this.activeTabName, params.zb)
      }达标比阶梯分布`;
      this.singletonSynthesizeScoreStepDistributionOutsourcerConfig.option = {
        title: {
          text: _text,
          textStyle: {
            fontSize: '14',
            fontWeight: '500',
          },
          left: 'center', // title 组件离容器左侧的距离。
        },
        tooltip: {
          formatter: (params) => {
            let text =              `${params[0].name || ''
            }&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;人数:${
              params[0].data.label.total_count
            }&nbsp;&nbsp;&nbsp;&nbsp;百分比:${
              (params[0].data.label.total_rate * 100).toFixed(2)
            }%`;
            params.map((item) => {
              text =                `${text
              }<br/>${
                item.seriesName
              }&nbsp;&nbsp;&nbsp;&nbsp;人数:${
                item.data.value
              }&nbsp;&nbsp;&nbsp;&nbsp;百分比:${
                (item.data.label.rate * 100).toFixed(2)
              }%`;
            });
            return text;
          },
        },
        legend: {
          data: legendData,
        },
        xAxis: [
          {
            type: 'category',
            data: xAxisData,
          },
        ],
        series,
      };
    },
    /**
     * 提质提效散点图
     */
    async getQualityEfficiencyScatterData(params = {}) {
      if (!params.production_line || params.production_line === '') {
        this.qualityEfficiencyScatterConfig.load = false;
        return;
      }
      const res = await getQualityEfficiencyScatter({
        ...params,
      });
      this.qualityEfficiencyScatterConfig.load = false;
      const xAxisName =        this.activeTabName === 'zhizuo' ? '验收一次缺陷率' : '内检人员缺陷率';
      const tooltipText = `${xAxisName}：`;
      const yAxisName = this.activeTabName === 'zhizuo' ? '制作效率' : '内检效率';
      const titleText = `${xAxisName}VS${yAxisName}`;
      let xAxisMax = 0;
      let yAxisMax = 0;
      const scatterData = [];
      let seriesMarkLineDataXAxis = 0;
      let seriesMarkLineDataYAxis = 0;
      if (res && res.points && res.points.length > 0) {
        const zlStandard = res.zl_standard || 0;
        const xlStandard = res.xl_standard || 0;
        xAxisMax = zlStandard * 100;
        yAxisMax = xlStandard;
        res.points.map((item) => {
          xAxisMax = item.zl * 100 > xAxisMax ? item.zl * 100 : xAxisMax;
          yAxisMax = item.xl > yAxisMax ? item.xl : yAxisMax;
          // 左上：高质高效，右上：低质高效，左下：高质低效，右下：低质低效
          // "zl_standard"//质量标准
          // "xl_standard"//效率标准
          const scatterDataText =            `${item.zl < zlStandard ? '高质' : '低质'
          }${
            item.xl > xlStandard ? '高效' : '低效'}`;

          const _zl = Number((item.zl * 100).toFixed(2));
          scatterData.push([
            _zl,
            item.xl,
            item.outsourcer,
            item.operator_cn,
            item.operator,
            scatterDataText,
          ]);
        });
        seriesMarkLineDataXAxis = Number((zlStandard * 100).toFixed(2));
        seriesMarkLineDataYAxis = Number(xlStandard.toFixed(2));
        this.isShowTip = true;
      }

      this.qualityEfficiencyScatterConfig.option = {
        iframe: this.isIframe,
        title: {
          text: titleText,
        },
        xAxis: {
          name: xAxisName,
          max: Number(xAxisMax.toFixed(2)),
          nameLocation: 'center',
          nameGap: '20',
        },
        yAxis: {
          name: yAxisName,
          max: Number(yAxisMax.toFixed(2)),
          nameLocation: 'end',
        },
        series: [
          {
            type: 'scatter',
            data: scatterData,
            tooltip: {
              formatter(params) {
                return (
                  `${params.value[2]
                  }:${
                    params.value[5]
                  }<br/>`
                  + `作业员：${
                    params.value[4]
                  }(${
                    params.value[3]
                  })`
                  + `<br/>${
                    tooltipText
                  }${params.value[0].toFixed(2)
                  }%`
                  + '<br/>'
                  + `效率：${
                    params.value[1].toFixed(2)}`
                );
              },
            },
            itemStyle: {
              color: 'rgba(85, 133, 237, 0.6)',
            },
          },
          {
            type: 'line',
            markLine: {
              lineStyle: {
                type: 'dashed',
                color: '#C23431',
              },
              data: [
                // 为了标准线两端都显示文字，所以每样标准必须两份
                {
                  xAxis: seriesMarkLineDataXAxis,
                  name: '质量标准',
                  label: {
                    normal: {
                      // 必须在normal中，不然不起作用
                      show: true,
                      position: 'end',
                      formatter: '高效',
                    },
                  },
                  tooltip: {
                    formatter: `质量标准:${seriesMarkLineDataXAxis}%`,
                  },
                },
                {
                  xAxis: seriesMarkLineDataXAxis,
                  name: '质量标准',
                  label: {
                    normal: {
                      show: true,
                      position: 'start',
                      formatter: '低效',
                    },
                  },
                  tooltip: {
                    formatter: `质量标准:${seriesMarkLineDataXAxis}%`,
                  },
                },
                {
                  yAxis: seriesMarkLineDataYAxis,
                  name: '效率标准',
                  label: {
                    normal: {
                      show: true,
                      position: 'start',
                      formatter: '高质',
                    },
                  },
                  tooltip: {
                    formatter: `效率标准:${seriesMarkLineDataYAxis}`,
                  },
                },
                {
                  yAxis: seriesMarkLineDataYAxis,
                  name: '效率标准',
                  label: {
                    normal: {
                      show: true,
                      position: 'end',
                      formatter: '低质',
                    },
                  },
                  tooltip: {
                    formatter: `效率标准:${seriesMarkLineDataYAxis}`,
                  },
                },
              ],
            },
          },
        ],
        fordata: params,
      };
    },
    /**
     * 提质提效柱状图
     */
    async getQualityEfficiencyComprehensiveData(params = {}) {
      if (!params.production_line || params.production_line === '') {
        this.qualityEfficiencyComprehensiveConfig.load = false;
        return;
      }
      const res = await getQualityEfficiencyComprehensive({
        ...params,
      });
      this.qualityEfficiencyComprehensiveConfig.load = false;
      const xAxisData = [];
      const seriesData = [];
      let total = 0;
      if (res && res.length > 0) {
        res.map((item) => {
          total = total + item.count;
          xAxisData.push(item.label);
          seriesData.push(item.count);
        });

        this.isShowTip = true;
      }
      this.qualityEfficiencyComprehensiveConfig.option = {
        title: {
          text: '质量效率综合评价分布',
        },
        xAxis: {
          type: 'category',
          data: xAxisData,
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            data: seriesData,
            type: 'bar',
            label: {
              show: true, // 开启显示
              position: 'top', // 在上方显示
              formatter: params => (
                `${params.data
                }(${
                  ((params.data / total) * 100).toFixed(2)
                }%)`
              ),
            },
            itemStyle: {
              color: '#334FC5',
            },
          },
        ],
      };
    },
    /**
     * 提质提效-分层效率分布
     */
    async getQualityEfficiencyEfficiencyData(params) {
      // 设置分层效率分布图数据
      if (!params.production_line || params.production_line === '') {
        this.qualityEfficiencyEfficiencyConfig.load = false;
        return;
      }

      const res = await getQualityEfficiencyEfficiency({ ...params });
      this.qualityEfficiencyEfficiencyConfig.load = false;

      let yAxisMax = 0;
      let dataYAxis = 0;
      const seriesData = [];
      if (res && res.data && res.data.length > 0) {
        yAxisMax = res.xl_standard || 0;
        dataYAxis = res.xl_standard || 0;
        res.data.map((item) => {
          yAxisMax = item.xl > yAxisMax ? item.xl : yAxisMax;
          seriesData.push([`${item.top * 100}%`, item.xl || 0, item.count]);
        });
        this.isShowTip = true;
      }
      this.qualityEfficiencyEfficiencyConfig.option = {
        title: {
          text: '分层效率分布图',
        },
        tooltip: {
          formatter(params) {
            const str =              `效率值：${
              Number(params[0].value[1]).toFixed(2)
            }<br/>`
              + `top：${
                params[0].value[0]
              }<br/>`
              + `top对应人数：${
                params[0].value[2]}`;
            return str;
          },
        },
        xAxis: {
          type: 'category',
        },
        yAxis: {
          max: yAxisMax.toFixed(2),
        },
        dataset: {
          source: seriesData,
        },
        series: {
          type: 'line',
          dimensions: ['top', 'xl', 'count'],
          markLine: {
            label: {
              show: true,
              position: 'insideEndTop',
            },
            data: [
              {
                name: '目标值',
                yAxis: dataYAxis,
                lineStyle: {
                  color: '#C23431',
                },
                symbolSize: 5,
              },
            ],
          },
        },
      };
    },
    /**
     * 提质提效-分层质量分布
     */
    async getQualityEfficiencyQualityData(params) {
      if (!params.production_line || params.production_line === '') {
        this.qualityEfficiencyQualityConfig.load = false;
        return;
      }
      const res = await getQualityEfficiencyQuality({ ...params });
      this.qualityEfficiencyQualityConfig.load = false;

      let yAxisMax = 0;
      let dataYAxis = 0;
      const seriesData = [];

      if (res && res.data && res.data.length > 0) {
        dataYAxis = res.zl_standard * 100;
        yAxisMax = res.zl_standard * 100;
        res.data.map((item) => {
          yAxisMax = item.zl * 100 > yAxisMax ? item.zl * 100 : yAxisMax;
          seriesData.push([
            `${item.top * 100}%`,
            (item.zl * 100).toFixed(2),
            item.count,
          ]);
        });
        this.isShowTip = true;
      }

      this.qualityEfficiencyQualityConfig.option = {
        title: {
          text: '分层质量分布图',
        },
        tooltip: {
          formatter(params) {
            let str = '';
            str
              += `质量值：${
                params[0].value[1]
              }%`
              + '<br/>'
              + `top：${
                params[0].value[0]
              }<br/>`
              + `top对应人数：${
                params[0].value[2]}`;
            return str;
          },
        },
        xAxis: {
          type: 'category',
        },
        yAxis: {
          axisLabel: {
            formatter(params) {
              return `${params.toFixed(2)}%`;
            },
          },
          max: yAxisMax,
        },
        dataset: {
          source: seriesData,
        },
        series: {
          type: 'line',
          dimensions: ['top', 'zl', 'count'],
          markLine: {
            label: {
              show: true,
              position: 'insideEndTop',
            },
            data: [
              {
                name: '目标值',
                yAxis: dataYAxis,
                lineStyle: {
                  color: '#C23431',
                },
                symbolSize: 5,
              },
            ],
          },
        },
      };
    },
    /**
     *获取图标series数据，stackBar格式化数据
     */
    getStackBarSeries(seriesObj) {
      const seriesArr = [];
      const _obj = Object.keys(seriesObj);
      const _len = _obj.length;

      for (let i = 0; i < _len; i++) {
        seriesArr.push({
          name: _obj[i],
          type: 'bar',
          stack: 'stackBar',
          label: {
            show: true, // 开启显示
          },
          data: seriesObj[_obj[i]],
        });
      }
      return seriesArr;
    },
    /**
     *人员单项下拉框变化，重新获取展示名称事件
     */
    getTitleText(activeTabName, dropDownNum) {
      let text = '';
      if (activeTabName === 'zhizuo') {
        text = '制作';
      }
      if (activeTabName === 'neijian') {
        text = '内检';
      }
      switch (dropDownNum) {
        case 1:
          text = `${text}质量`;
          break;
        case 2:
          text = `${text}效率`;
          break;
        case 3:
          text = `${text}产量`;
          break;
        case 4:
          text = `${text}有效时长`;
          break;
        default:
          break;
      }
      return text;
    },
    /**
     *筛选条件-产线change事件
     */
    onProdLineValueChange(val) {
      this.initOutsourcertaskType({ // 调取任务类型 根据产线
        operator_type: this.activeTabName,
        start_time: this.formData.start_time,
        end_time: this.formData.end_time,
        production_line: this.formData.production_line,
        platform: this.formData.platform
      });
      this.initOutsourcerOptions({
        operator_type: this.activeTabName,
        start_time: this.formData.start_time,
        end_time: this.formData.end_time,
        production_line: this.formData.production_line,
        platform: this.formData.platform
      }); // 筛选获取供应商
      // if(this.formData.production_line === '')
    },
    /**
     *筛选条件-任务类型change事件
     */
    onTaskTypeValueChange(val) {
      this.initOutsourcertaskLabel({ // 调取任务标签 根据任务类型
        operator_type: this.activeTabName,
        start_time: this.formData.start_time,
        end_time: this.formData.end_time,
        production_line: this.formData.production_line,
        platform: this.formData.platform,
        outsourcer: this.formData.outsourcer,
        task_type: this.formData.task_type,
      });
      this.initOutsourcerOptions({
        operator_type: this.activeTabName,
        start_time: this.formData.start_time,
        end_time: this.formData.end_time,
        production_line: this.formData.production_line,
        platform: this.formData.platform,
      }); // 筛选获取供应商
    },
    /**
     * 筛选条件-产线clear事件
     */
    onProdLineValueClear() {
      // 清空产线时清理提质提效评价中四个图标数据
      this.isShowTip = false;
      this.qualityEfficiencyScatterConfig.clear = true;
      this.qualityEfficiencyComprehensiveConfig.clear = true;
      this.qualityEfficiencyEfficiencyConfig.clear = true;
      this.qualityEfficiencyQualityConfig.clear = true;
    },
    /**
     * 把onProdLineValueClear方法中设置的clear设置为false，方便内部watch
     * */
    onProdLineValueClearReset() {
      this.qualityEfficiencyScatterConfig.clear = false;
      this.qualityEfficiencyComprehensiveConfig.clear = false;
      this.qualityEfficiencyEfficiencyConfig.clear = false;
      this.qualityEfficiencyQualityConfig.clear = false;
      this.comprehensiveScoreTimeTrendGraph.clear = true;
      this.evaluationDimensionTimeTrend.clear = true;
    },
    /**
     * 筛选条件-供应商change事件
     */
    onSupplierValueChange(val) {
      this.initProdLineOptions({
        operator_type: this.activeTabName,
        start_time: this.formData.start_time,
        end_time: this.formData.end_time,
        outsourcer: this.formData.outsourcer,
        platform: this.formData.platform,
        time_type: this.formData.time_type,
      }); // 筛选获取产线
    },
    /**
     *筛选-查询点击事件
     */
    onInquireClick() {
      this.UPDATE_INQRIRENUM();
      // 图标数据调用
      this.drawCharts({
        ...this.formData,
        operator_type: this.activeTabName,
      }); // 绘制图表
      this.onProdLineValueClearReset();
    },
    /**
     *筛选-重置点击事件
     */
    onResetClick(formName) {
      // 重置
      this.$refs[formName].resetFields();
      this.onProdLineValueClear();
      this.taskTypeChange = false;
      this.formData.task_type = '';
    },
    async exportDetail(type) {
      const params = {
        ...this.formData,
        operator_type: this.activeTabName,
      };
      if (!params.production_line || params.production_line === '') {
        this.$message.info('导出操作未选择产线，请选择!');
        return;
      }
      let data = '';
      switch (type) {
        case '1':
          data = await getQualityEfficiencyScatterExport(params);
          break;
        case '2':
          data = await getQualityEfficiencyComprehensiveExport(params);
          break;
        case '3':
          data = await getQualityEfficiencyEfficiencyExport(params);
          break;
        case '4':
          data = await getQualityEfficiencyQualityExport(params);
          break;
        default:
          break;
      }
      if (data !== '') {
        downloadBlobFile(data);
      }
    },
    /**
     * 平台改变时回掉参数
     * @param value
     */
    onPlatformChange(value) {
      this.taskTypeChange = false;
      this.formData.production_line = '';
      this.formData.task_type = '';
      this.formData.task_label = '';
      this.tasktypeOptions = [];
      this.initProdLineOptions({
        ...this.formData,
        operator_type: this.activeTabName,
      });
    },
    // // pv指数上报
    async PV_report() {
      await api.pv_report({ type: 2, t: Date.parse(new Date()) });
    },
    evaluationDimensionTimeTrendChange(event = '') {
      this.evaluationDimensionTimeTrend.load = true;
      this.evaluationDimensionTimeTrend.clear = true;
      this.getEvaluationDimensionTimeTrend({
        ...this.formData,
        operator_type: this.activeTabName,
      });
    },
    comprehensiveScoreTimeTrendChange(event = '') {
      this.comprehensiveScoreTimeTrendGraph.load = true;
      this.comprehensiveScoreTimeTrendGraph.clear = true;
      this.getComprehensiveScoreTimeTrendGraph({
        ...this.formData,
        operator_type: this.activeTabName,
      });
    },
    dimensionChange(event, key) {
      if (key === 'comprehensiveScoreTimeTrendGraph') {
        this.comprehensiveScoreTimeTrendGraph.load = true;
        this.comprehensiveScoreTimeTrendGraph.clear = true;
        this.getComprehensiveScoreTimeTrendGraph({
          ...this.formData,
          operator_type: this.activeTabName,
        });
        return;
      }
      this.evaluationDimensionTimeTrendChange();
    },
  },
};
</script>
<style lang="less" scoped>
.personnel-portrait-content {
  flex: 1;
  display: flex;
  flex-flow: column;
  padding-left: 20px;
  max-width: 100%;
  width: 100%;
  min-width: 100%;
  .content-header {
    width: 100%;
    height: auto;
    .el-form-item {
      margin: 5px;
    }
    /deep/ .el-tabs__header {
      padding-left: 5px;
      margin: 0;
    }
  }
  .content {
    flex: 1;
    overflow: auto;
    display: flex;
    flex-flow: column;
    max-width: 100%;
    width: 100%;
    min-width: 100%;
    .content-row {
      display: -webkit-box !important; /**兼容QQ浏览器，高度没有自动撑开问题 */
      display: flex;
      flex-flow: row;
      max-width: 100%;
      width: 100%;
      min-width: 100%;
      margin: 5px 0;
      .content-column {
        background-color: #ffffff;
        flex: 1;
        display: flex;
        flex-flow: column;
        padding: 5px 20px;
        width: 100%;
        .content-title {
          //height: 40px;
          font-size: 14px;
          font-weight: bold;
          color: rgba(7, 16, 49, 1);
          line-height: 40px;
          position: relative;
          .export-span {
            position: absolute;
            right: 0;
            color: #2cb9b8;
            cursor: pointer;
            z-index: 9999;
          }
        }
      }
      .content-column-50 {
        max-width: 50%;
        width: 50%;
        min-width: 50%;
      }
      .content-column-30 {
        max-width: 30%;
        width: 30%;
        min-width: 30%;
      }
      .content-column-70 {
        max-width: 70%;
        width: 70%;
        min-width: 70%;
      }
      .br5 {
        border-right: 5px solid #f0f2f5;
      }
      .bl5 {
        border-left: 5px solid #f0f2f5;
      }
    }
  }
}
.tabs {
  & /deep/ #tab-zhizuo {
    width: 96px;
    text-align: center;
  }

  & /deep/ #tab-neijian {
    width: 96px;
    text-align: center;
  }
}
</style>
<style lang="less">
.tooltip-overflow {
  padding: 0 0 0 10px;
  ::-webkit-scrollbar {/*滚动条整体样式*/
    width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
    /*height: 5px;*/
  }
  ::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    background-color: #868889;
    /*background-image: -webkit-linear-gradient(45deg, rgba(255, 93, 143, 1) 25%,
     transparent 25%, transparent 50%, rgba(255, 93, 143, 1) 50%, rgba(255, 93, 143, 1) 75%, transparent 75%,
     transparent);*/
  }
  ::-webkit-scrollbar-track {/*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px #c9ccce;
    background: #fff;
  }
}
</style>
